import Bloodhound from 'Bloodhound';
import Handlebars from 'Handlebars';
import 'typeahead';

/**
 * An airline field including auto-suggest.
 *
 * @type {Object}
 */
var airlineField = {

  /**
   * Initializes the airlineField plugin.
   * @param  {Object} jQuery Under which element we want to
   *                                        track for events.
   */
  init: function() {

    ;(function ( $, window, document, undefined ) {

      // Create the defaults once
      var pluginName = "airlineField",
          defaults = {
            i18n: require('./i18n/en')
          };

      // The actual plugin constructor
      function Plugin ( element, options ) {
          this.element = element;
          this.settings = $.extend( {}, defaults, options );
          this._defaults = defaults;
          this._name = pluginName;
          this.init();
      }

      // Avoid Plugin.prototype conflicts
      $.extend(Plugin.prototype, {

          init: function () {

            var self = this;
            var $airlineField = $(this.element);
            var airlines,
                airlineASTemplateSource,
                airlineASTemplate;

            // A handy class to test for before trigger. If it's there yet do
            // not trigger the plugin again on the element.
            $airlineField.addClass('hasAirlineSuggestions');
            // Instantiates the Bloodhound suggestion engine for the airlines.
            airlines = new Bloodhound({
              datumTokenizer: function(d) {
                return d;
              },
              queryTokenizer: Bloodhound.tokenizers.whitespace,
              remote: {

                url: 'https://flights.flightright.net/airlines?query=%QUERY', 
                wildcard: '%QUERY',
                filter: function (airlines) {
                  // Maps the remote source JSON array to a JavaScript object array
                  return $.map(airlines, function (airline) {
                    return {
                      iata: airline.iata,
                      name: airline.name,
                      value: airline.name
                    };
                  });
                },
                rateLimitBy : 'debounce',
                rateLimitWait : 100
              },
              limit: 10
            });

            // Initializes the Bloodhound suggestion engine for the aiports.
            airlines.initialize();

            airlineASTemplateSource = '<div>{{name}}</div>';
            airlineASTemplate = Handlebars.compile(airlineASTemplateSource);


            // Instantiates the Autosuggest UI for the airlines fields.
            $airlineField.typeahead({
              highlight: true,
              minLength: 1
            },
            {
              name: 'airlines',
              source: airlines.ttAdapter(),
              templates: {
                empty: [
                  '<span class="fw-bold  red  pd-Asm">',
                  self.settings.i18n.noResult,
                  '</span>'
                ].join('\n'),
                suggestion: function(data) {
                  return airlineASTemplate(data);
                }
              }
            }).on('typeahead:selected', function (event, data, name) {
              // Sets the iata as the submit value for the airlines
              $(event.target).attr('data-submit', data.iata);
              $(event.target).attr('data-city', data.name);
              $(event.target).attr('data-display', data.name);
              $(event.target).attr('data-value', data.iata);
              $(event.target).attr('data-selected', 'true');
              $(event.target).attr('data-searched', 'true');
              $(event.target).trigger('airlineField:set');
            }).on('typeahead:opened', function (event) {
              // Sets selected back to false to track wheter the user did a selection
              $(event.target).attr('data-selected', 'false');
            }).on('typeahead:closed', function (event) {
              // Sets submit value back to empty
              var $target = $(event.target);
              var submit = $target.attr('data-submit');
              var display = $target.attr('data-display');
              var selected = $target.attr('data-selected');

              // If change w/o selection to not empty value (e.g manual change)
              if(selected === 'false' && display !== $target.val() && $target.val().length > 0) {
                // Puts back former display value
                $(event.target).val(display);
              }
              // If change w/o selection to empty value (e.g manual deletion)
              else if($target.val().length === 0) {
                // Resets data submit
                $(event.target).removeAttr('data-submit').removeAttr('data-selected');
              }
            });
          }
      });

      // A really lightweight plugin wrapper around the constructor,
      // preventing against multiple instantiations
      $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
          if ( !$.data( this, "plugin_" + pluginName ) ) {
            $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
          }
        });
      };
    })( jQuery, window, document );
  }
};

module.exports = airlineField;
